<template lang="pug">
section#v-ticketing: .container
  h2 TICKETING
  ul
    li
      label 日期：
      em 8 月 31 日
    li
      label 時間：
      | 09:00~17:30
    li
      label 地點：
      | 台北市信義區松仁路123號（華南國際會議中心 3 樓）
  a(href='https://kktix.com/tickets_widget?slug=connect2019', target='_blank') 立即購票
</template>

<script>
export default {
  name: 'Ticketing',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-ticketing
  +background(url(~@/assets/ticketing-background.png))
  padding: 60px
h2
  +font(42px, white, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 50px
ul
  +border(1px, #DFFF00)
  margin-bottom: 50px
  padding: 30px 50px
  list-style-type: none
  li
    +font(26px, #F7F7F7, 50px, .65px, 500)
    em
      color: #DFFF00
a
  +border(3px, #DFFF00, 100px)
  +flex(center, center)
  +font(30px, white, null, .75px, bold)
  +size(320px, 70px)
  margin-left : auto
  margin-right: auto
  &:hover
    text-decoration: none

@media (max-width: 1023px)
  #v-ticketing
    +background(url(~@/assets/m-ticketing-background.png))
    padding: 30px 0 40px
  h2
    +font(30px, null, null, .75px)
    margin-bottom: 30px
  ul
    border: none
    margin-bottom: 30px
    padding: 0
    li
      +font(20px, null, 40px, .5px)
      display: flex
      label
        flex: none
        width: 3.5em
  a
    +font(22px, null, null, .55px)
    +size(180px, 55px)
</style>
